module.exports = __webpack_public_path__ + "static/media/upload_image.fd2583f8.svg";